import { Box, Text, Tooltip } from '@chakra-ui/react';
import { Remove } from 'amazon-chime-sdk-component-library-react';

import { useThemeMode } from '@providers/ThemeModeProvider';

type Props = {
  title: string;
  onClose?: () => void;
  onCloseTooltipText?: string;
};

function BlockTitle({ title, onClose, onCloseTooltipText }: Props) {
  const { styles } = useThemeMode();

  const renderCloseButton = () => {
    if (!onClose) {
      return null;
    }

    const CloseButton = (
      <Box
        position="absolute"
        right="12px"
        top="12px"
        cursor="pointer"
        onClick={onClose}
      >
        <Remove width="2rem" />
      </Box>
    );

    if (onCloseTooltipText) {
      return (
        <Tooltip
          label={onCloseTooltipText}
          placement="auto"
          hasArrow
          bg="gray.700"
        >
          {CloseButton}
        </Tooltip>
      );
    }

    return CloseButton;
  };

  return (
    <Box
      p={4}
      borderBottomWidth="1px"
      height="fit-content"
      borderBottomColor={styles.borderColor}
      color={styles.label}
      position="relative"
      mt={{ base: 4, md: 0 }}
    >
      <Text>{title}</Text>
      {renderCloseButton()}
    </Box>
  );
}

export default BlockTitle;
